import { useState, useRef } from 'react';
import API from '../api';
import { HttpErrorHandler } from '../utils/ErrorHandler';

export function useStandDocumentUpload({ refreshList, showSnackbar, setSnackbarText } = {}) {
  const [selectedItem, setSelectedItem] = useState(null);
  const [document, setDocument] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const uploadRef = useRef();

  const handleUpload = async (endpoint) => {
    if (!document || !selectedItem?.id) return;

    const formData = new FormData();
    formData.append('document', document);

    setUploading(true);
    try {
      const response = await API.post(`/${endpoint}/${selectedItem.id}/document`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      // Aggiorna selectedItem con il nuovo document_url ricevuto dalla risposta
      const updatedStand = response.data;
      console.log(updatedStand);

      setSelectedItem((prev) => ({
        ...prev,
        document_url: updatedStand.url,
      }));

      refreshList?.();
      showSnackbar(true, 'Documento caricato');
    } catch (error) {
      HttpErrorHandler(error, setSnackbarText);
      showSnackbar(false);
    } finally {
      setUploading(false);
      setDocument(null);
    }
  };

  const handleDelete = async (endpoint) => {
    if (!selectedItem?.id || !selectedItem?.document_url) return;

    setDeleting(true);
    try {
      await API.delete(`/${endpoint}/${selectedItem.id}/document`);
      refreshList?.();
      showSnackbar(true, 'Documento eliminato');
      // Aggiorna stato per rimuovere document_url
      setSelectedItem((prev) => ({
        ...prev,
        document_url: null,
      }));
      setDocument(null);
    } catch (error) {
      HttpErrorHandler(error, setSnackbarText);
      showSnackbar(false);
    } finally {
      setDeleting(false);
    }
  };

  const cdnUrl = (url) =>
    url?.replace('https://media-upload-gestionale.s3.us-east-2.amazonaws.com', 'https://dd67njibr1th7.cloudfront.net');

  const copyLink = (url) => {
    navigator.clipboard.writeText(cdnUrl(url));
    showSnackbar(true, 'Link del documento copiato negli appunti');
  };

  const formatSize = (size) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
    if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(2)} MB`;
    return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  };

  const getIcon = (file) => {
    if (!file?.name) return '/assets/icons/ic_default.svg';
    const ext = file.name.split('.').pop().toLowerCase();
    return `/assets/icons/ic_${ext}.svg` || '/assets/icons/ic_default.svg';
  };

  return {
    selectedItem,
    setSelectedItem,
    document,
    setDocument,
    uploadRef,
    uploading,
    deleting,
    handleUpload,
    handleDelete,
    cdnUrl,
    copyLink,
    formatSize,
    getIcon,
  };
}
